import React from "react";
import { Link } from "react-router-dom";

const FooterCTA = () => {
  return (
    <div className="relative py-20 bg-gradient-to-r from-[#fff44f] via-[#fff86f] to-[#fffcb0] overflow-hidden">
      {/* Soft Background Illustration or Pattern */}
      <div
        className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] bg-repeat"
        aria-hidden="true"
      ></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
          Let’s Move Your Business Forward
        </h2>
        <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
          Partner with{" "}
          <span className="text-red-600 font-bold">S Infinite Express</span> for
          reliable, tech-powered logistics that scale with your growth.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link
            to="/contact-us"
            className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 shadow hover:shadow-lg"
          >
            Get Started Today
          </Link>

          <Link
            to="/get-a-quote"
            className="bg-white border border-gray-300 hover:border-red-600 text-gray-800 hover:text-red-600 px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 shadow-sm hover:shadow-md"
          >
            Get Quote
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FooterCTA;
